import { useEffect, useState } from "react";
import { _BudgetRPFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Singleton } from "../../../core/services/Singleton";
import { CDPsEditor } from "./CDPsEditor";
import { InputMoney } from "../../theme/Input/InputMoney";
import { ObjectDinamicViewer } from "../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";
import { PrintJson } from "../../theme/Component/PrintJson";

interface FormProps {
    BudgetIDStr: string;
    JsonCode: string;
    IDDocument: number;
    DocumentDate: any;
    IDBudgetResource: number;
    IDBudgetSource: number;
    Description: string;
    Value: number;
    MaxValue: number;
}

interface Props {
    formData: any;
    contract: any;
    onChange: Function;
}
export const RegisterRFContract = ({ formData, contract, onChange }: Props) => {

    // const validModificate = formData.ContractSearched ? false : true;
    const validModificate = true;

    const _budgetRDFactory = useDataBean(_BudgetRPFactory);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [bean, setBean] = useState<Partial<FormProps>>({});
    const [initBean, setInitBean] = useState<any>({});

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalAssingCDP, setModalAssingCDP] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalBudget, setModalBudget] = useState<any>({ name: 'Seleccione el Rubro Presupuestal a Afectar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (formData.ContractSearched) {
            _budgetRDFactory.instance.getBudgetIDListForAdquisitionContract(contract.IDAdquisitionContract, contract.AdquisitionContractDate).then(
                (resp: any) => {
                    setLista(resp);
                    //console.log("Resouetsa del servicio", resp)
                }
            ).catch(err => toast.error(err))
        }
    }, [contract])

    useEffect(() => {
        onChange(lista)
    }, [lista])

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente Presupuestal', property: 'BudgetSourceName', visible: true },
        { title: 'Certificado de Disponibilidad Presupuestal', property: 'CDPDocument', visible: true },
        { title: 'Vr Certificado de Disponibilidad', property: 'CDPValue', visible: true, mask: MASK_MONEY },
        { title: 'Vr CDP por Comprometer', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor a Comprometer', property: 'Value', visible: true, mask: MASK_MONEY },
    ]

    const headBudget = [
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Valor CDP', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Valor Restante de CDP', property: 'CDPLeft', visible: true, mask: MASK_MONEY },
        { title: 'Valor RCDP/RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
    ]

    const createItems = () => {
        _budgetRDFactory.instance.createBudgetRowForRP(
            bean.BudgetIDStr,
            bean.IDDocument,
            bean.DocumentDate,
            bean.IDBudgetResource,
            bean.IDBudgetSource,
            bean.Description,
            bean.Value
        ).then((resp) => {

            console.log("Respuesta del backend:", resp);

            const updatedLista = lista.filter((item: any) =>
                !(item.DataBeanProperties.BudgetIDStr === resp.BudgetIDStr &&
                    item.DataBeanProperties.IDBudgetResource === resp.IDBudgetResource &&
                    item.DataBeanProperties.IDBudgetSource === resp.IDBudgetSource)
            );

            let temp = [...updatedLista, {
                DataBeanProperties: resp,
                DataBeanName: 'budget.Budget'
            }];

            setLista(temp)

            _budgetRDFactory.setBean({});
            setBean({});
            setModal({ ...modal, "view": false });
            setModalAssingCDP({ ...modalAssingCDP, "view": false });

        }).catch((err) => {
            console.error("Error al crear ítem:", err);
            toast.error(err);
        });
    };


    const createBudget = () => {
        setBean({});
        _budgetRDFactory.setBean({});
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: (validModificate), icono: 'ri-file-add-line', evento: () => { createBudget() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Relacionar CDP', icono: 'ri-file-add-line', visible: !validModificate, evento: () => { setModalAssingCDP({ ...modalAssingCDP, "view": true, "name": "Relacionar CDP" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: validModificate, evento: () => { eliminarItem() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const setRowBean = (objeto: any) => {
        setBean(objeto);
        setInitBean(objeto)
    }

    const selectBudget = () => {
        setBean({
            ...bean,
            IDBudgetResource: _budgetRDFactory.bean.IDBudgetResource,
            BudgetIDStr: _budgetRDFactory.bean.BudgetIDStr,
            IDBudgetSource: _budgetRDFactory.bean.IDBudgetSource,
        });

        setModalBudget({ ...modalBudget, "view": false });
    }

    useEffect(() => {
        if (bean.IDDocument != _budgetRDFactory.bean.IDDocument) {
            getBudgetByDoc();
        }
    }, [bean])

    const getBudgetByDoc = () => {
        _budgetRDFactory.instance.getCDPBudgetByDocument(bean.IDDocument, bean.DocumentDate).then(
            (resp) => {
                setModalBudget({ ...modalBudget, "view": true })
                _budgetRDFactory.setLista(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    useEffect(() => {
        if (modalBudget.view === true) {
            _budgetRDFactory.setBean({})
        }
    }, [modalBudget.view])

    return (
        <div className="row">
            <p>Valor del contrato: ${formData.ContractValue}</p>
            <div className="col">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={(e) => { setRowBean(e) }} />
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createItems}>
                    <div className="row">
                        <div className="col-md-12">
                            <CDPsEditor contrat={formData.ContractSearched ? formData.Contract : null} onChange={(e) => { setBean({ ...bean, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate }) }} value={bean.IDDocument} label="Selector de Certificado Disponibilidad Presupuestal" />
                        </div>
                        {bean.IDBudgetResource &&
                            <div className="col-md-12">
                                <label >Rubro Seleccionado  <a className={`pointer ${_budgetRDFactory.bean.IDDocument ? "" : "d-none"}`} onClick={() => {
                                    setModalBudget({ ...modalBudget, "view": true, "name": "Seleccione un rubro" })
                                    setBean({ ...bean, IDBudgetResource: null, IDBudgetSource: null, BudgetIDStr: null })
                                }}>¿Cambiar?</a></label>
                                <ObjectDinamicViewer data={_budgetRDFactory.bean} head={headBudget} />
                            </div>
                        }
                        <div className="col-md-12">
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, Value: e }) }} _label="Valor" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} ></textarea>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modalBudget} updateModal={setModalBudget} eventModal={() => {
                                if (_budgetRDFactory.bean.IDBudgetResource && _budgetRDFactory.bean.IDBudgetSource) {
                                    selectBudget()
                                } else {
                                    toast.error("Presupuesto no valido")
                                }
                            }} onSubmitLabel="Seleccionar" >
                                <BasicTable listButtons={listaBotones()} head={headBudget} body={_budgetRDFactory.lista} rowSet={_budgetRDFactory.setBean} />
                            </Modal>
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalAssingCDP} updateModal={setModalAssingCDP} eventModal={() => { createItems() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <CDPsEditor contrat={contract} onChange={(e) => { setBean({ ...bean, IDDocument: e.IDDocument, DocumentDate: e.DocumentDate }) }} value={bean.IDDocument} label="Selector de Certificado Disponibilidad Presupuestal" />
                        </div>
                        {bean.IDBudgetResource &&
                            <div className="col-md-12">
                                <label >Rubro Seleccionado  <a className={`pointer ${_budgetRDFactory.bean.IDDocument ? "" : "d-none"}`} onClick={() => {
                                    setModalBudget({ ...modalBudget, "view": true, "name": "Seleccione un rubro" })
                                    setBean({ ...bean, IDBudgetResource: null, IDBudgetSource: null, BudgetIDStr: null })
                                }}>¿Cambiar?</a></label>
                                <ObjectDinamicViewer data={_budgetRDFactory.bean} head={headBudget} />
                            </div>
                        }
                        <div className="col-md-12">
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, Value: e }) }} _label="Valor" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} ></textarea>
                        </div>

                        <div className="col-md-12">
                            <Modal modal={modalBudget} updateModal={setModalBudget} eventModal={() => {
                                if (_budgetRDFactory.bean.IDBudgetResource && _budgetRDFactory.bean.IDBudgetSource) {
                                    selectBudget()
                                } else {
                                    toast.error("Presupuesto no valido")
                                }
                            }} onSubmitLabel="Seleccionar" >
                                <BasicTable listButtons={listaBotones()} head={headBudget} body={_budgetRDFactory.lista} rowSet={_budgetRDFactory.setBean} />
                            </Modal>
                        </div>
                    </div>
                </Modal>
            </div>

        </div>
    )
}